const styles = (theme) => ({
  card: {
    marginBottom: 3,
    minHeight: "80px",
    "& $disableIcon": {
      cursor: "not-allowed",
      opacity: 0.5,
      pointerEvents: "all",
      color: theme.iconColor,
    },
  },
  disableIcon: {
    cursor: "not-allowed",
    opacity: 0.7,
    pointerEvents: "all",
    marginTop: 8,
    color: theme.iconColor,
  },
  enableIcon: {
    cursor: "pointer",
    marginTop: 8,
    color: theme.iconColor,
  },
  title: {
    color: theme.dispatchPanelLabelValueColor,
    fontSize: theme.textFontSize,
  },
  subheader: {
    color: theme.iconColor,
    fontSize: theme.dispatchCardTextFontSize,
  },
  headerRoot: {
    padding: 8,
    backgroundColor: theme.ModalBGColor,
  },
  statusWrapper: {
    height: 24,
    display: "flex",
    justifyContent: "space-between",
  },
  statusTime: {
    color: theme.gridTextColor,
    lineHeight: 2,
    marginRight: 8,
    fontSize: theme.textFontSize,
    fontWeight: 600,
    marginLeft: 10,
  },
  noPadding: {
    padding: "0px",
    borderTop: `1px solid ${theme.AppBGColor}`,
    "&:last-child": {
      paddingBottom: 0,
    },
  },
  avatar: {
    marginRight: "6px",
  },
});

export default styles;
